import { useMutation } from '@tanstack/react-query';
import { container } from '@src/container';
import { AuthService } from '@src/application/users/usecases';

/**
 * Hook: useGenerateWhatsAppCode
 * Generates a code for linking WhatsApp account
 * 
 * @example
 * const { mutate: generateCode, data, isPending } = useGenerateWhatsAppCode();
 * generateCode();
 */
export function useGenerateWhatsAppCode() {
    const authService = container.resolve<AuthService>('authService');

    return useMutation({
        mutationFn: async () => {
            return await authService.generateWhatsAppLinkCode();
        },
        // Disable retries - user can manually retry
        retry: false,
    });
}
